import { toast } from 'sonner';
import { ApiError, GENERIC_ERROR_MESSAGE_ES } from '@lombok/api-client';

/**
 * Per-mutation switches read from `useMutation({ meta })`.
 * - `inlineError`: the form shows the error itself (FormError); skip the toast.
 * - `successMessage`: opt-in success toast for the main actions only.
 */
export interface MutationToastMeta extends Record<string, unknown> {
  inlineError?: boolean;
  successMessage?: string;
}

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: MutationToastMeta;
  }
}

/** Errors that must stay silent: a 401 sends the user to login, not to a toast. */
function isSilent(error: unknown): boolean {
  return error instanceof ApiError && error.isUnauthorized;
}

export function notifyMutationError(error: unknown, meta: MutationToastMeta | undefined): void {
  if (meta?.inlineError || isSilent(error)) return;
  if (error instanceof ApiError) {
    toast.error(error.message, {
      description: error.requestId ? `Código de referencia: ${error.requestId}` : undefined,
    });
    return;
  }
  toast.error(GENERIC_ERROR_MESSAGE_ES);
}

export function notifyMutationSuccess(meta: MutationToastMeta | undefined): void {
  if (meta?.successMessage) toast.success(meta.successMessage);
}
